import { handleActions } from 'redux-actions';
import update from 'immutability-helper';

import {
	GET_IS_REFRESH_QR_CODE_EXISTS_CALL,
	GET_IS_REFRESH_QR_CODE_EXISTS_DONE,
	GET_IS_REFRESH_QR_CODE_EXISTS_FAIL,
	GET_REFRESH_QR_CODE_CALL,
	GET_REFRESH_QR_CODE_DONE,
	GET_REFRESH_QR_CODE_FAIL,
} from '../types/qrcode';

const defaultSideEffectState = {
	isLoading: false,
	isLoaded: false,
	error: null,
};

const initialState = {
	refreshQRCode: {},
	getRefreshQRCodeSideEffect: defaultSideEffectState,
	getIsRefreshQRCodeExistsSideEffect: defaultSideEffectState,
};

export default handleActions({
	[GET_REFRESH_QR_CODE_CALL](state) {
		return update(state, {
			getRefreshQRCodeSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[GET_REFRESH_QR_CODE_DONE](state, { payload: { res } }) {
		return update(state, {
			refreshQRCode: { $set: res },
			getRefreshQRCodeSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[GET_REFRESH_QR_CODE_FAIL](state, { payload }) {
		return update(state, {
			getRefreshQRCodeSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},
	[GET_IS_REFRESH_QR_CODE_EXISTS_CALL](state) {
		return update(state, {
			getIsRefreshQRCodeExistsSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[GET_IS_REFRESH_QR_CODE_EXISTS_DONE](state) {
		return update(state, {
			getIsRefreshQRCodeExistsSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[GET_IS_REFRESH_QR_CODE_EXISTS_FAIL](state, { payload }) {
		return update(state, {
			getIsRefreshQRCodeExistsSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},
}, initialState);
